import React, { Component } from "react";
import { Float } from "@cnsit/js";
import { Ω } from "../components/Ω";
import { V } from "../components/V";
import { I } from "../components/I";
import { W } from "../components/W";

export class VOIW extends Component {
  constructor(props) {
    super(props);
    this.state = {
      volt: props.volt,
      ohm: props.ohm
    };
    this.onVoltChange = this.onVoltChange.bind(this);
    this.onOhmChange = this.onOhmChange.bind(this);
    this.v = React.createRef();
    this.o = React.createRef();
  }
  componentDidMount() {
    this.setState(
      {
        volt: this.v.current.unify(),
        ohm: this.o.current.unify()
      },
      () => {
        this.calc();
      }
    );
  }
  onVoltChange(id, value) {
    this.setState({ volt: value }, () => {
      this.calc();
    });
  }
  onOhmChange(id, value) {
    this.setState({ ohm: value }, () => {
      this.calc();
    });
  }
  calc() {
    let vrms = new Float(this.state.volt).div(2.828);
    let power = new Float(vrms).pow(2).div(this.state.ohm);
    let amp = new Float(this.state.volt).div(this.state.ohm);
    this.setState({ power: power, vrms: vrms, amp: amp }, () => {});
  }
  render() {
    return (
      <div className="calculator">
        <V
          value={this.props.volt}
          onChange={this.onVoltChange}
          caption="电压pp"
          ref={this.v}
        />
        <V value={this.state.vrms} caption="电压rms" readonly={true} />
        <Ω
          value={this.props.ohm}
          scaleIndex={2}
          onChange={this.onOhmChange}
          caption="电阻"
          ref={this.o}
        />
        <I value={this.state.amp} readonly={true} />
        <W value={this.state.power} readonly={true} />
      </div>
    );
  }
}
